import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getPayments() {
    yield takeEvery(actions.FETCH_PAYMENTS_REQUESTED, function* (action) {
        try {
          const payments = yield call(actions.getPayments, action.payload);
          yield put({ type: actions.FETCH_PAYMENTS_SUCCEEDED, payments });
        } catch (error) {
          yield put({ type: actions.FETCH_PAYMENTS_FAILED, error: error.message });
        }
    });
}

export function* getPayment() {
    yield takeEvery(actions.FETCH_PAYMENT_REQUESTED, function* (action) {
        try {
            const payment = yield call(actions.getPayment, action.payload);
            yield put({ type: actions.FETCH_PAYMENT_SUCCEEDED, payment: payment.payment_info });
        } catch (error) {
            yield put({ type: actions.FETCH_PAYMENT_FAILED, error: error.message });
        }
    });
}

export default function* rootSaga() {
  yield all([
    fork(getPayments),
    fork(getPayment)
  ]);
}
